import * as Yup from 'yup';
import { Formik } from 'components/form/formik';
import toast from 'react-hot-toast';
import { captureException } from '@sentry/react';
import { trackEvent } from '../../../../../utils/track-event';

import { DataField } from 'components/DataField';
import { useCreateIncassoCtx } from './context';
import { decimateAndFormatNumber } from '@utils/number';
import { formatDate } from '@utils/date';
import { Button } from 'components/button/Button';
import { createIncasso } from '../../../models';
import { getDisplayError } from '@utils/get-display-error';
import { InputField } from 'components/input/InputField';
import { useNavigate } from 'react-router-dom';

const incassoSchema = Yup.object().shape({
  trackingId: Yup.string().required('Vereist'),
  partner: Yup.string().required('Vereist'),
});

export const IncassoCreationOverview: React.FC = (props) => {
  const navigate = useNavigate();
  const { state } = useCreateIncassoCtx();

  const customer = state.selectedCustomer;
  const invoices = state.selectedInvoices;
  const total = invoices.reduce((sum, invoice) => sum + invoice.totalInclVat, 0);

  return (
    <div>
      <DataField title="Klant">
        {customer ? `${customer.name} (#${customer.id}) - ${customer.vatNumber}` : 'Geen klant geselecteerd'}
      </DataField>

      <div className="mt-8">
        <div className="heading-two mb-2">Facturen</div>
        <div>
          {state.selectedInvoices.map((v) => {
            return (
              <div key={v.id} className="mb-4 py-2 border-b border-border">
                <div className="font-medium">{v.invoiceNumber}</div>
                <div>{`Datum: ${formatDate(v.date)}`}</div>
                <div>
                  {`Totaal incl btw: €${decimateAndFormatNumber(v.totalInclVat, 2, {
                    decimalSeperator: ',',
                  })}`}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div>
        <span className="font-medium">Totaal van alle facturen:</span>{' '}
        {`€${decimateAndFormatNumber(total, 2, {
          decimalSeperator: ',',
        })}`}
      </div>

      <div className="my-8 max-w-2xl">
        <Formik
          initialValues={{
            trackingId: '',
            partner: '',
          }}
          validationSchema={incassoSchema}
          onSubmit={async (values) => {
            try {
              const res = await createIncasso({
                invoiceIds: state.selectedInvoices.map((invoice) => invoice.id),
                partner: values.partner,
                trackingId: values.trackingId,
              });

              if (!res) {
                throw new Error('Kon incasso niet aanmaken');
              }

              trackEvent('incasso_created', {
                incasso_id: res.id,
                invoice_count: state.selectedInvoices.length,
                partner: values.partner,
              });
              navigate(`/internal/finance/incasso/${res.id}`, { replace: true });
              toast.success('Incasso aangemaakt');
            } catch (err) {
              captureException(err);
              toast.error('Kon incasso niet aanmaken: ' + getDisplayError(err));
            }
          }}
        >
          {({ handleSubmit, isSubmitting }) => (
            <form onSubmit={handleSubmit}>
              <InputField labelText="Partner" name="partner" />
              <InputField labelText="Tracking ID" name="trackingId" />

              <Button type="submit" color="primary" isDisabled={isSubmitting} isLoading={isSubmitting}>
                Incasso aanmaken
              </Button>
            </form>
          )}
        </Formik>
      </div>
    </div>
  );
};
